<template>
  <div class="container mt-25">
    <section class="main-form" v-if="!showSuccess">
      <div class="center bold-font grey-text mt-10">
        Pay to: {{businessName}}
      </div>
      <section class='mt-10 grey-text center' v-if='showTips'>
        <tips :qid="merchantQidParam" :tips-updated="tipsUpdated"></tips>
      </section>
      <div class="row mt-10">
        <div class="input-field col s6 m4"  v-if="amountEditable">
          <i class="fas fa-dollar-sign prefix grey-text"></i>
          <input
            name="amount"
            id="amount"
            @input="updateAmounts"
            autofocus
            v-model='amount'
            step="0.01"
            type="text" 
            inputmode="decimal"
            v-validate="'min_value:0.01|required'"
            class='inputText'
            lang="en-001">

          <label for="amount">Amount</label>
        </div>
        <div class='col s12' v-else>
          <h3 class="bold-font center">Amount: {{amount | currency}}</h3>
        </div>
      </div>
      <div class="row mt-10">
        <div class="input-field col s12 m6">
          <i class="fas fa-random prefix grey-text"></i>
          <input
            v-model="routing"
            id="routing"
            type="text"
            class="validate"
            :class="{'invalid': errors.has('routing')}"
            v-validate="'required|regex:^[0-9]+$'"
            name="routing"
            @blur="validate('routing')">

          <label for="routing" :class="{'active': routing}">Routing</label>
          <span class="helper-text" :data-error="errors.first('routing')"></span>
        </div>
        <div class="input-field col s12 m6">
          <i class="fas fa-hashtag prefix grey-text"></i>
          <input v-model="accountNumber" id="accountNumber" type="text" class="validate" v-validate="'required|regex:^[0-9]+$'" name="Account Number">
          <label for="accountNumber">Account Number</label>
          <span class="red-text" v-show="errors.has('Account Number')">{{ errors.first('Account Number') }}</span>
        </div>
      </div>

      <div class="row">
        <div class="input-field col s12 m6">
          <i class="fas fa-user prefix grey-text"></i>
          <input v-model="firstName" id="firstName" type="text" class="validate">
          <label for="firstName">First Name</label>
        </div>
        <div class="input-field col s12 m6">
          <input v-model="lastName" id="lastName" type="text" class="validate">
          <label for="lastName">Last Name</label>
        </div>
      </div>

      <div class="row">
        <div v-if="presetInvoice.length > 0" class="large-font center mt-25">
          <i class="fas fa-file-invoice prefix grey-text"></i>
          Invoice: <span class="bold-font">{{invoice}}</span>
        </div>
        <div v-else class="input-field col s12 m6">
          <i class="fas fa-file-invoice prefix grey-text"></i>
          <input v-model="invoice" id="invoice" type="text" class="validate" ref="invoice">
          <label for="invoice">Invoice</label>
        </div>

        <div class="input-field col s12 m6">
          <i class="fas fa-sticky-note prefix grey-text"></i>
          <input v-model="note" id="note" type="text" class="validate">
          <label for="note">Note</label>
        </div>
      </div>

      <button class="btn-large wide-btn mt-10" type="submit" name="action" @click="submit" :disabled="!submittable" v-if="!processing">
        Pay {{grossAmount | currency}}
      </button>

      <div v-else class='grey-text center mt-10'>
        <i class="fas fa-spinner fa-spin grey-text"></i> 
        Processing ...
      </div>

      <div style="display: flex; align-items: center;" class="red-text mt-10" v-if="gVerifyError && gVerifyChecked && !processing">
        <i class="fas fa-info-circle" style="margin-right: 10px; font-size: 18px;"></i>
        <span>
          <strong>Notice:</strong> {{gVerifyError}} But you can still proceed.
        </span>
      </div>

      <div class="center grey-text mt-5" v-if="feeAmount > 0">
        Gross Amount: <b>{{grossAmount | currency}}</b> |  
        Non-cash adjustment: <b>{{feeAmount | currency}}</b>
      </div>
      <div class="grey-text small-font center">Agree to be charged up to the amount on the contract</div>
    </section>
    <section v-else class="mt-25 center">
      <h3 class='emerald bold-font'>
        <i class="fas fa-check fa-3x"></i><br>
        Successfully Paid
      </h3>
    </section>
  </div>
</template>
<script>
  import tips from "../tips"

  export default {
    components: { tips },
    created() {
      this.$dom.watch() // to render icons
      this.updateAmounts()
      this.$nextTick(() => {
        M.updateTextFields();
      });
    },
    props: [
      "merchantQidParam",
      "presetAmount",
      "presetInvoice",
      "presetNote",
      "presetFirstName",
      "presetLastName",
      "amountEditable",
      "showTips",
      "businessName",
      "checkoutSessionId",
      "performGverify"
    ],
    data() {
      return {
        amount: this.presetAmount,
        invoice: this.presetInvoice === '' ? null : this.presetInvoice,
        note: this.presetNote === '' ? null : this.presetNote,
        routing: null,
        accountNumber: null,
        firstName: this.presetFirstName === '' ? null : this.presetFirstName,
        lastName: this.presetLastName === '' ? null : this.presetLastName,
        processing: false,
        grossAmount: 0,
        feeAmount: 0,
        selectedTip: 0,
        tipCustomAmount: 0,
        lastGrossCalcRequestId: 0,
        showSuccess: false,
        gVerifyChecked: false,
        gVerifyError: null
      }
    },
    methods: {
      processGverify() {
        this.$http.post("/api/v1/public/adyen_gverify", this.gVerifyParams).then(() => {
          this.gVerifyChecked = true
          this.processAch()
        }, error => {
          this.gVerifyChecked = true
          if(error.status == 422) {
            this.gVerifyError = error.body.errors[0]
          } 
        })
      },
      processAch() {
        this.processing = true

        if(this.tipAmount < 20 || confirm(`Confirm ${this.tipAmountFormatted} tip amount`)){
          this.processAchPayment()
        }
      },
      processAchPayment() {
        this.processing = true
        this.$validator.validateAll().then((result) => {
          if (result) {
            this.$http.post("/api/v1/public/checkout_sessions/ach_payments", this.achPaymentsParams).then(response => {
              this.showSuccess = true
              this.notifySuccess("Transaction successfully processed")
            }, error => {
              this.processing = false
              this.gVerifyError = null
              this.errorHandler(error)
            })
          } else {
            this.processing = false
            this.notifyError("Please complete all required fields!")
          }
        })

      },
      async updateAmounts() {
        this.lastGrossCalcRequestId++

        const requestId = this.lastGrossCalcRequestId
        const response = await this.$http.get("/api/v1/vue/gross_ach_calculations", {
          params: {
            amount: this.amount,
            tip_percent: this.selectedTip,
            tip_custom_amount: this.tipCustomAmount,
            qid: this.merchantQidParam,
          }
        });

        if (requestId === this.lastGrossCalcRequestId) {
          this.grossAmount = response.body.gross_amount;
          this.feeAmount = response.body.fee;
          this.withTipAmount = response.body.amount_with_tip;
          this.tipAmount = response.body.tip_amount;
          this.tipAmountFormatted = response.body.tip_amount_formatted;
        }
      },
      tipsUpdated(selectedTip, tipCustomAmount) {
        this.selectedTip = selectedTip
        this.tipCustomAmount = tipCustomAmount
        this.updateAmounts()
      },
      validate(field) {
        console.log("Validating field", field)
        this.$validator.validate(field)
      }
    },
    computed: {
      achPaymentsParams() {
        return {
          amount: this.amount,
          account_number: this.accountNumber,
          routing: this.routing,
          first_name: this.firstName,
          last_name: this.lastName,
          note: this.note,
          invoice: this.invoice,
          tip_percent: this.selectedTip,
          tip_amount: this.tipAmount,
          checkout_session_id: this.checkoutSessionId
        }
      },
      gVerifyParams() {
        return {
          qid: this.merchantQidParam,
          routing: this.routing,
          account_number: this.accountNumber,
          first_name: this.firstName,
          last_name: this.lastName
        }
      },
      submittable() {
        // Check if none of the properties are null or undefined
        return this.amount !== null && this.amount !== undefined && this.amount > 0 &&
               this.routing !== null && this.routing !== undefined &&
               this.accountNumber !== null && this.accountNumber !== undefined &&
               this.firstName !== null && this.firstName !== undefined &&
               this.lastName !== null && this.lastName !== undefined;
      },
      submit() {
        if (this.performGverify && !this.gVerifyChecked) {
          return this.processGverify;
        }
        return this.processAch;
      }
    } 
  }
</script>
